import React, { ChangeEvent, createRef } from 'react';
import './textarearesize.css';

interface Props {
    className    : string;
    text         : string;
    minRows?     : number;
    maxRows?     : number;
    style?       : React.CSSProperties;
    editMode     : boolean;
    placeholder? : string;
    id?          : string;
    name?        : string;

    onChange? : (text : string) => void;
    onEnter?  : () => void;
}

interface State {
    text     : string;
    height   : string | number;
}

export class TextAreaResize extends React.Component<Props, State> {
    textareaRef = createRef<HTMLTextAreaElement>();

    constructor(props: Props) {
        super(props);
        this.state = { 
            height   : 'auto',
            text     : props.text
        };
    }

    componentDidMount() {
        this.resizeTextarea();
    }

    componentDidUpdate(prevProps: Props) {
        if (prevProps.text !== this.props.text) {
            this.setState({
                text : this.props.text
            }, this.resizeTextarea.bind(this));
        }
    }

    focus()
    {
        this.textareaRef.current?.focus();
    }

    getLineHeight(element: HTMLTextAreaElement): number {
        const computedStyle = window.getComputedStyle(element);
        let height = parseInt(computedStyle.lineHeight || '20', 10);

        if (Number.isNaN(height)) {
            return 10;
        }

        return height;

    }

    getText()
    {
        return this.state.text;
    }

    onCancel()
    {
        this.setState(
            { text : this.props.text },
            this.resizeTextarea.bind(this)
        );
    }

    onChange(e: ChangeEvent<HTMLTextAreaElement>) 
    {
        if (this.props.editMode) {
            this.setState(
                { text : e.target.value }, 
                this.resizeTextarea.bind(this)
            );

            if (this.props.onChange !== undefined) {
                this.props.onChange(e.target.value);
            }
        }
    }

    onKeyDown(e: React.KeyboardEvent<HTMLTextAreaElement>) 
    {
        if (e.key === 'Enter' && !e.shiftKey) {
            if (this.props.onEnter) {
                this.props.onEnter();
                e.preventDefault();
            }
        }
    }

    resizeTextarea() {
        const textarea = this.textareaRef.current;
        if (textarea) {
            // Reset height to auto to shrink if needed
            textarea.style.height = 'auto';
            
            let maxHeight = 10 * parseFloat(getComputedStyle(document.documentElement).fontSize);
            let newHeight = Math.min(textarea.scrollHeight, maxHeight);
            
            textarea.style.height = newHeight + 'px';
            textarea.style.overflowY = textarea.scrollHeight > maxHeight ? "auto" : "hidden";
            this.setState({ height: newHeight });
        }
    };

    render() {
        let classes = 'textarearesize';
        if (this.props.className !== undefined) {
            classes += ' ' + this.props.className;
        }

        return (
            <textarea
                name={this.props.name}
                id={this.props.id}
                className={ classes }
                readOnly={ !this.props.editMode }
                placeholder= { this.props.placeholder }
                ref={this.textareaRef}
                value={this.state.text}
                onChange={(e) => { this.onChange(e) }}
                onKeyDown={(e) => { this.onKeyDown(e) }}
                style={{ 
                    cursor: (this.props.editMode ? undefined : "default"),
                    resize: "none",
                    overflow: "hidden"
                }}
                rows={this.props.minRows}
                suppressHydrationWarning={true}
                />
            );
    }
}

